import PhotoSwipeLightbox from "../vendor/photoswipe/photoswipe-lightbox.esm";
import PhotoSwipe from "../vendor/photoswipe/photoswipe.esm";
// import hasWebp from './lib/has-webp';

(async () => {
  const options = {
    gallerySelector: ".list-realisations",
    childSelector: ".item .m-cardImage",
    pswpModule: PhotoSwipe,
  };

  // swap jpg srcset on link if navigator has webp support
  // if (await hasWebp()) {
  // for each gallery
  // const swapGalleries = document.querySelectorAll(options.gallerySelector);
  // if (swapGalleries.length > 0) {
  //   for (const swapGallery of swapGalleries) {
  //     // for each photoswipe link in this gallery
  //     const swapLinks = swapGallery.querySelectorAll(options.childSelector);
  //     if (swapLinks.length > 0) {
  //       for (const swapLink of swapLinks) {
  //         const picture = swapLink.parentElement;
  //         const source = picture.querySelector("source");
  //         const srcset = source.getAttribute("srcset");
  //         swapLink.dataset.pswpSrcset = srcset;
  //       }
  //     }
  //   }
  // }
  // }

  const lightbox = new PhotoSwipeLightbox(options);
  lightbox.init();
  console.log("pswipe");
})();
